.wrapper {
  border-radius: var(--border-radius-sm);
  color: var(--color-link-enabled);
  position: relative;
  vertical-align: baseline;
}

.link {
  color: var(--color-link-enabled);
  text-decoration: none;
}
